
<template>
    <div class="product-type-container">
        <ThatsTable title="Product Types" ref="table" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns">
            <template #customBtns>
                <mdb-btn color="elegant" icon="star-of-life" size="sm" class="mr-auto mt-0" @click="openBulkWindow">Bulk</mdb-btn>
            </template>
        </ThatsTable>
        <ProductTypeForm ref="dialogForm" @success="refreshTable" @delete="formDelete"></ProductTypeForm>
        <ProductTypeBulkForm ref="bulkForm" @success="refreshTable"></ProductTypeBulkForm>
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ProductTypeForm from './ProductTypeForm'
import ThatsTable from '../../components/thats/Table'
import ProductTypeBulkForm from './ProductTypeBulkForm'
import { mdbBtn } from 'mdbvue'
export default {
    data(){
        return {
            endpoint : 'product-types'
        }
    },
    components: {
        ProductTypeForm,
        ProductTypeBulkForm,
        ThatsTable,
        mdbBtn
    },

    methods: {
        ...mapActions('ProductTypeModule', ['deleteRecord']),
        ...mapMutations('ProductTypeModule',[ 'setFormRecord', 'setFormStatusUpdate']),

        formDelete(record){
            this.DispatchDelete([record.row]);
        },
        DispatchDelete(items){
            this.deleteRecord(items).then(() => this.refreshTable());
        },

        OpenUpdateModal(obj){
            this.setFormStatusUpdate()
            this.setFormRecord(obj)
            this.openWindow()
        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        openBulkWindow(){
            this.$refs.bulkForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        }
    },
    computed: {
        ...mapGetters('ProductTypeModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ]),
    },
}
</script>
<style scoped>
.product-type-container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>
